import { Link } from "react-router";
import { Logo } from "../logo";
import { t } from "@lingui/macro";

export default function Header() {
  return (
    <header className="absolute top-2 z-30 w-full md:top-2">
      <div className="px-4 sm:px-6">
        <div className="mx-auto max-w-3xl">
          <div className="flex h-14 items-center justify-between overflow-hidden rounded-lg border border-transparent px-3 [background:linear-gradient(var(--color-white),var(--color-white))_padding-box,linear-gradient(120deg,var(--color-zinc-300),var(--color-zinc-100),var(--color-zinc-300))_border-box]">
            {/* Site branding */}
            <div className="mr-4 shrink-0">
              {/* Logo */}
              <Link className="flex items-center justify-center gap-3 rounded-sm bg-white" to="/">
                <div className="relative top-[-1px] flex h-10 w-10 items-center">
                  <Logo />
                </div>
                <h1 className="text-xl font-semibold">CVKit</h1>
              </Link>
            </div>

            {/* Desktop navigation */}
            <nav className="relative flex h-full grow overflow-hidden select-none">
              <div className="text-foreground flex grow flex-wrap items-center justify-end pr-1 font-medium">
                <div className="stars-container">
                  <div className="star"></div>
                  <div className="star star-large"></div>
                  <div className="star"></div>
                  <div className="star"></div>
                  <div className="star star-large"></div>
                  <div className="star"></div>
                  <div className="star"></div>
                  <div className="star"></div>
                  <div className="star star-large"></div>
                  <div className="star"></div>
                  <div className="star star-large"></div>
                  <div className="star"></div>
                </div>
                <div className="mr-2 flex items-center gap-2">
                  <span className="bg-gradient-to-r from-black to-gray-400 bg-clip-text text-2xl font-extrabold text-transparent">
                    {t`Pro`}
                  </span>
                </div>
                <span>{t`Career Builder`}</span>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}
